import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson2DefaultStartCode = `%lang starknet
from starkware.cairo.common.alloc import alloc

// Getting pointer as function arguments let us modify the values at the memory address of the pointer
// ...or not! Cairo memory is immutable. Therefore you cannot just update a memory cell.
${doNotModifyCodeAbove}`;

export const lesson2DefaultMiddleCode = `// TODO: Update the square function
// to make it achieve the desired result: returning an array
// with the squared values of the input array.

func square(array : felt*, updated_array : felt*, array_len : felt) {
    if (array_len == 0) {
        return ();
    }


    return square(array + 1, updated_array + 1, array_len - 1);
}`;

export const lesson2DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_square{syscall_ptr : felt*}() {
    alloc_locals;
    let (local array : felt*) = alloc();

    assert [array] = 1;
    assert [array + 1] = 2;
    assert [array + 2] = 3;
    assert [array + 3] = 4;

    let (local updated_array : felt*) = alloc();

    square(array, updated_array, 4);

    assert 1 = [updated_array];
    assert 4 = [updated_array + 1];
    assert 9 = [updated_array + 2];
    assert 16 = [updated_array + 3];

    return ();
}`;
